<template>
	<div class="innovationBox">
		<!-- 核心swiper -->
		<div :class="'swiper-innovation'+indexa" class="innovation">
			<div class="swiper-wrapper">
				<div class="swiper-slide" v-for="(item,index) in list" :key="index" @click="goDetail(item)">
					<div class="swiper-slide-img">
						<img :src="item.url" />
					</div>
					<div class="swiper-slide-wz " :class="activeIndex==index?' ':''" style="animation-duration: 1s;">
						<div class="swiper-slide-wz-name">
							<div v-for="(itema,indexa) in item.other.bigTitle" :key="indexa">
								{{itema.title}}
							</div>
						</div>
						<div class="swiper-slide-wz-cen">
							<div v-for="(itema,indexa) in item.other.smallTitle" :key="indexa" :style="{
								height:itema.title?'':'20px',
								letterSpacing: '0.1em'
							}">
								{{itema.title}}
							</div>
						</div>
					</div>
				</div>
			</div>
			<div class="swiper-innovation-prev" :style="{
					display:prev,
				}">
				<img src="@/assets/innovation/cxz.png" />
			</div>
			<div class="swiper-innovation-next" :style="{
					display:next,
				}">
				<img src="@/assets/innovation/cxy.png" />
			</div>
			<div class="swiper-innovation-scrollbar">
				<div class="swiper-scrollbar-drag"></div>
				<!-- <div style="position:relative;width: 100%;height: 6px;">
				<div class="swiper-scrollbar-drag" :style="{
					width:widthSide+'%',
					left:liftSide+'%'
				}"></div>
			</div>
			 -->
			</div>
		</div>
	</div>
</template>

<script>
	export default {
		components: {

		},
		props: {
			list: {
				typeof: Array,
				default: []
			},
			indexa: {
				typeof: Number,
				default: 0
			}
		},
		data() {
			return {
				mySwiper: '',
				activeIndex: 1,
				prev: 'none',
				next: 'block',
			}
		},
		mounted() {
			let t = this;
			// autoplay: {
			// 	delay: 3000,
			// 	disableOnInteraction: false,
			// },
			let name = '.swiper-innovation' + this.indexa
			this.mySwiper = new this.$swiper(name, {
				// 方向
				direction: 'horizontal',
				// 自动播放
				autoplay: false,
				scrollbar: {
					el: ".swiper-innovation-scrollbar",
					draggable: true,
				},
				navigation: {
					prevEl: ".swiper-innovation-prev",
					nextEl: ".swiper-innovation-next",
				},
				centeredSlides: true,
				observer: true,
				observeParents: true,
				on: {
					slideChangeTransitionEnd() {
						t.activeIndex = this.activeIndex;
						if (this.activeIndex === 0) {
							t.prev = 'none';
						} else {
							t.prev = 'block';
						}
						if (this.activeIndex === this.slides.length - 1) {
							t.next = 'none';
						} else {
							t.next = 'block';
						}
					},

				},
			});

		},
		methods: {
			// next(){
			// 	this.mySwiper.slideNext()
			// },
			// prev(){
			// 	this.mySwiper.slidePrev()
			// }
			goDetail(e) {
				console.log(e)
				this.$emit('goDetail', e)
				// this.$router.push({
				// 	path:'/innovationDetail',
				// 	name:'innovationDetail',
				// 	query:{
				// 		id:e.id,
				// 		infoId:e.info_id
				// 	}
				// })
			}
		}
	}
</script>

<style>

</style>
<style scoped lang="scss">
	.innovationBox {
		margin-bottom: 60px;
	}

	.innovation {
		overflow: hidden;
		position: relative;

		.swiper-innovation-prev {
			position: absolute;
			top: 50%;
			left: 35px;
			z-index: 99;

			img {
				width: 52px;
				height: 52px;
			}

			display: flex;
			align-items: center;
			justify-content: center;
			border-radius: 100%;
			transform: translateY(-50%);
			transition: all 0.3s ease;
			cursor: pointer;
		}

		.swiper-innovation-next {
			transform: translateY(-50%);
			position: absolute;
			top: 50%;
			right: 35px;
			z-index: 99;
			border-radius: 100%;
			display: flex;
			align-items: center;
			justify-content: center;
			transition: all 0.3s ease;
			cursor: pointer;

			img {
				width: 52px;
				height: 52px;
			}
		}

		.swiper-innovation-scrollbar {
			position: absolute;
			bottom: 20px;
			z-index: 999;
			left: 65px;
			background-color: #666;
			width: 124px;
			height: 2px;
		}

		// /* 修改滚动条滑块的颜色 */
		.swiper-scrollbar-drag {
			background-color: #fff;
			// transition: all 0.3s ease-in-out;
			// position: absolute;
			// left: 0;
		}
	}

	.swiper-slide {
		position: relative;

		.swiper-slide-img:hover {
			img {
				transform: scale(1.1);
			}
		}

		.swiper-slide-img {
			width: 100%;
			height: 600px;
			overflow: hidden;
			cursor: pointer;

			img {
				width: 100%;
				height: 600px;
				object-fit: cover;
				transition: all 0.3s ease-in-out;
			}
		}

		.swiper-slide-wz {
			position: absolute;
			bottom: 80px;
			left: 65px;

			.swiper-slide-wz-name {
				font-size: 36px;
				
				font-weight: 400;
				color: #FFFFFF;
				margin-bottom: 32px;
			}

			.swiper-slide-wz-cen {
				font-size: 24px;
				
				font-weight: 400;
				color: #FFFFFF;
			}
		}

	}

	@media screen and (max-width:1200px) {
		.innovationBox {
			margin-bottom: 30px !important;
		}

		.swiper-slide-wz-name {
			font-size: 24px !important;
			padding: 0 30px !important;
		}

		.swiper-slide-wz-cen {
			font-size: 16px !important;
			width: 100% !important;
			padding: 0 30px !important;
			box-sizing: border-box;
		}

	}
</style>